// - Basic settings - //

  // server
  export const API_URL = 'https://api.pelhrimov.qtcloud.cz';
  
  // 'https://api.qtcloud.cz'; - Tetronik testovaci server
  // 'http://31.31.72.155:8888'; - SoFair testovaci


  // Google maps api key
  export const GOOGLE_API_KEY = 'AIzaSyCFn5kJ0M9ANeXrgVLgOiQLgCdetZgJGXo';

  // google recapcha v2
  export const CAPRCHA_CLIENT_KEY = '6LchWxYUAAAAAHS5JBSMFlSP3Fu-uHNr47WYzU0W';

  export const APP_TITLE = '';

  // single office mode
  export const SINGLE_OFFICE_MODE = false;

  // graph statistics
  // - default: month or year 
  export const STATS_DEFAULT_SETTING = 'year';
  // - if switching is bad idea
  export const STATS_SHOW_DATE_SWITCH = true;

// -------------------- //


// ~ Colors ~ //

  // color 1 
  //  - main color in header and selected button
  export const COLOR_1 = '#2a485f';
  export const COLOR_1_BORDER_BOTTOM = '#2a485f';
  export const COLOR_1_BORDER_LEFT = '#2a485f';

  // color 2
  // - color in header under logo
  export const COLOR_2 = '#0B2E49';
  export const COLOR_2_BORDER_BOTTOM = '#0B2E49';
  export const COLOR_2_BORDER_RIGHT = '#0B2E49';

  // color 3
  //  - side panel color
  export const COLOR_3 = '#004267';
  export const COLOR_3_BORDER_RIGHT = '#004267';

// -------------------- //
